<template>
  <div v-if="chosenChildOrg && childOrgsSelector && componentName">
    <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center">
      <v-btn
        v-if="componentName !== 'form-a'"
        dense class="button white__v-btn mr-2" :to="'/form-' + prevFormName"
      >
        Предыдущая форма
      </v-btn>
      <div class="structural-unit">
        <label>Выбор структурного подразделения</label>
        <v-autocomplete
          v-model="selectorId"
          :items="childOrgsSelector"
          @change="selectOrganization(selectorId)"
          dense
          outlined
        ></v-autocomplete>
      </div>
      <v-btn
        v-if="componentName !== 'form-g'"
        dense class="button white__v-btn" :to="'/form-' + nextFormName"
      >
        Следующая форма
      </v-btn>
    </div>
    <header-main class="fives-forms" :title="textBodyHeader" :subtitle="subtextBodyHeader">
      <template v-if="thirdText">
        <span style="color: #00599B; font-size: 12px">{{ thirdText }}</span>
      </template>
    </header-main>
    <component :is="componentName" :text-body-header="textBodyHeader" :organizationBlocked="organizationBlocked"
               :chosenChildOrg="chosenChildOrg"/>
  </div>
</template>

<script>
import inProgress from '@/components/InProgress';
import HeaderMain from "@/components/headers/HeaderMain";
import formA from "@/pages/Organization/dopForms/formA";
import formG from "@/pages/Organization/dopForms/formG";
import formB from "@/pages/Organization/dopForms/formB";
import formV from "@/pages/Organization/dopForms/formV";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "dopFormsForms",
  components: {
    HeaderMain,
    inProgress,
    'form-a': formA,
    'form-g': formG,
    'form-b': formB,
    'form-v': formV,
  },
  data() {
    return {
      componentName: 'inProgress',
      textBodyHeader: '',
      subtextBodyHeader: '',
      thirdText: '',
      defaultComponent: {name: 'inProgress', formId: 'inProgress', text: 'В процессе разработки'},
      componentsData: [
        {
          name: 'form-a',
          formId: '/form-a',
          text: 'Таблица A.',
          textBodyHeader: 'Сведения о трудоустройстве выпускников (очная форма обучения)',
          subtextBodyHeader: 'расчет на основе данных подсистемы «Анализ трудоустройства граждан» информационно-аналитической системы Общероссийская база вакансий «Работа в России» (Минтруд России)'
        },
        {
          name: 'form-b',
          formId: '/form-b',
          text: 'Таблица Б.',
          textBodyHeader: 'Численность выпускников, имевших в году, следующем за годом завершения обучения (выпуска), последнее место трудоустройства по субъектам РФ (независимо от формы обучения)',
          subtextBodyHeader: 'расчет на основе данных подсистемы «Анализ трудоустройства граждан» информационно-аналитической системы Общероссийская база вакансий «Работа в России» (Минтруд России)'
        },
        {
          name: 'form-v',
          formId: '/form-v',
          text: 'Таблица В.',
          textBodyHeader: 'Среднемесячный размер заработной платы выпускников по УГСН (НПС), имевших в году, следующем за годом завершения обучения (выпуска), последнее место трудоустройства по субъектам РФ (независимо от формы обучения)',
          subtextBodyHeader: 'расчет на основе данных подсистемы «Анализ трудоустройства граждан» информационно-аналитической системы Общероссийская база вакансий «Работа в России» (Минтруд России)'
        },
        {
          name: 'form-g',
          formId: '/form-g',
          text: 'Таблица Г.',
          textBodyHeader: 'Перечень научно-исследовательских, опытно-конструкторских и технологических работ (НИОКТР) срок реализации которых на 1 января года проведения конкурса не истек',
          subtextBodyHeader: 'по данным ЕГИСУ НИОКТР'
        },
      ],
      childOrgs: [],
      childOrgsSelector: [],
      chosenChildOrg: null,
      selectorId: null,
    }
  },
  computed: {
    ...mapGetters('spr', {getAvailableOrgs: 'getAvailableOrgs'}),
    ...mapGetters('checkFilled', {organizationBlocked: 'organizationBlocked'}),
    
    prevFormName() {
      if (this.componentName.slice(5) === 'b') {
        return 'a'
      } else if (this.componentName.slice(5) === 'v') {
        return 'b'
      } else if (this.componentName.slice(5) === 'g') {
        return 'v'
      } else {
        return ''
      }
    },
    
    nextFormName() {
      if (this.componentName.slice(5) === 'a') {
        return 'b'
      } else if (this.componentName.slice(5) === 'b') {
        return 'v'
      } else if (this.componentName.slice(5) === 'v') {
        return 'g'
      } else {
        return ''
      }
    }
  },
  
  created() {
    this.initComponent();
  },
  
  watch: {
    $route() {
      this.initComponent();
    },
    getAvailableOrgs() {
      this.initComponent();
    }
  },
  
  methods: {
    ...mapActions('spr', {changeSelectedOrg: 'changeSelectedOrg'}),
    initComponent() {
      const form = this.$route.path;
      const component = this.componentsData.find(el => form === el.formId);
      this.componentName = component?.name ?? this.defaultComponent.name;
      this.textBodyHeader = component?.text + ' ' + component?.textBodyHeader;
      this.subtextBodyHeader = component?.subtextBodyHeader;
      this.thirdText = component?.html;
      this.$route.meta.title = (component?.text + component?.textBodyHeader) ?? this.defaultComponent.text;
      
      if (this.chosenChildOrg === null || this.chosenChildOrg === undefined) {//первая загрузка
        this.childOrgs = this.getAvailableOrgs;
        this.childOrgsSelector = this.getAvailableOrgs.map((el) => {
          return {
            text: el.name,
            value: el?.id,
          }
        });
        this.selectorId = this.childOrgs[0]?.id;
        this.chosenChildOrg = this.childOrgs[0];
        this.changeSelectedOrg(this.chosenChildOrg);
      }
      
    },
    
    selectOrganization(orgId) {
      if (orgId) {
        this.chosenChildOrg = this.childOrgs.find(el => el?.id === orgId);
        this.changeSelectedOrg(this.chosenChildOrg);
      }
    },
  },
}
</script>

<style scoped>

</style>